import { render, staticRenderFns } from "./PasswordMessageScreen.vue?vue&type=template&id=c5d24e3c"
import script from "./PasswordMessageScreen.vue?vue&type=script&lang=js"
export * from "./PasswordMessageScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports